import { createAction, props } from '@ngrx/store';
import { Warehouse } from '../_models';

// Action types
export const loadWarehouses = createAction('[Warehouse] Load Warehouses');
export const loadWarehousesSuccess = createAction(
  '[Warehouse] Load Warehouses Success',
  props<{ warehouses: Warehouse[] }>()
);
export const loadWarehousesFailure = createAction(
  '[Warehouse] Load Warehouses Failure',
  props<{ error: any }>()
);

export const addWarehouse = createAction(
  '[Warehouse] Add Warehouse',
  props<{ warehouse: Warehouse }>()
);
export const addWarehouseSuccess = createAction(
  '[Warehouse] Add Warehouse Success',
  props<{ warehouse: Warehouse }>()
);
export const addWarehouseFailure = createAction(
  '[Warehouse] Add Warehouse Failure',
  props<{ error: any }>()
);

export const updateWarehouse = createAction(
  '[Warehouse] Update Warehouse',
  props<{ warehouse: Warehouse }>()
);
export const updateWarehouseSuccess = createAction(
  '[Warehouse] Update Warehouse Success',
  props<{ warehouse: Warehouse }>()
);
export const updateWarehouseFailure = createAction(
  '[Warehouse] Update Warehouse Failure',
  props<{ error: any }>()
);

export const deleteWarehouse = createAction(
  '[Warehouse] Delete Warehouse',
  props<{ id: number }>()
);
export const deleteWarehouseSuccess = createAction(
  '[Warehouse] Delete Warehouse Success',
  props<{ id: number }>()
);
export const deleteWarehouseFailure = createAction(
  '[Warehouse] Delete Warehouse Failure',
  props<{ error: any }>()
);
